let sale_discounts = document.querySelectorAll('[id^="discount-"]');
let percentage = 0;
let badge_id = sale_discounts[0].getAttribute("parent");
for (let i = 0; i < sale_discounts.length; i++) {
  if (sale_discounts[i].getAttribute("parent") != badge_id) {
    if (percentage === 0) {
      percentage = sale_discounts[i].innerHTML;
      //percentage_pos = i;
    } else {
      let up_to_value = document.getElementById(badge_id);
      up_to_value.innerHTML = "Up to " + percentage + "% Off";
      percentage = sale_discounts[i].innerHTML;
      //percentage_pos = i;
      badge_id = sale_discounts[i].getAttribute("parent");
    }
  } else {
    if (parseInt(sale_discounts[i].innerHTML) >= parseInt(percentage)) {
      percentage = sale_discounts[i].innerHTML;
      //percentage_pos = i;
    }
  }
  if (i === sale_discounts.length - 1) {
    let up_to_value = document.getElementById(badge_id);
    up_to_value.innerHTML = "Up to " + percentage + "% Off";
    percentage = sale_discounts[i].innerHTML;
  }
}
